import { componentsToColor } from "pdf-lib";

const initialState = {
  documentMenu: {},
  jsonMeta: {},
  fileMenu: {},
  docRecords: [],
  totalDocRecords: 0,
  hasNextPage: false,
  folderRecords: [],
  totalFolderRecords: 0,
  folder: null,
  details: {},
  fileData: {},
  documentData: null,
  documentDataId: null,
  baseDirectory: {},
  fileVersions: [],
  revisions: [],
  docUrl: null,
  latestVersion: null,
  latestRevision: null,
  selectedVersion: null,
  queueCount: 0,
  filter: '',
  isOn: null,
  accepted: 0,
  page: 1,
  folderPage: 1,
  totalPages: 0,
  cIcon: 0,
  fileRefreshFlag: false,
  isRightClicked: false,
  validationJson: {},
  enableButton: true,
  view: false,
  activeId: 0,
  prevFile: null,
  documentLogs: [],
  selectedRevision: "",
  selectedFileId:'',
  myAssigned: false,
  openedTab: [],
  hasNextFolderPage:false,
  hasPrevFolderPage:false,
  folderLabel: 4,
  folderSort: 2
}
export const document = (state = initialState, action) => {
  switch (action.type) {
    case "LIST_DOCUMENT_MENU": {

      console.log('case "LIST_DOCUMENT_MENU"', action.data)
      return {
        ...state,
        documentMenu: action.data,
        totalFolderRecords: action.data?.totalDocs ? action.data.totalDocs : 0,
        folderPage: action.data?.page ? action.data.page : 1,
        totalPages: action.data?.totalPages ? action.data.totalPages : 0,
        totalDocRecords: action.data.totalDocuments !== undefined ? action.data.totalDocuments : 0,
        folder: action.data.docs !== undefined && action.data?.docs.length ? action.data?.docs[0]._id : null,
        baseDirectory: action.data.docs !== undefined && action.data?.docs.length ? action.data?.docs[0].directory : {},
        folderRecords: action.data?.docs !== undefined ? action.data?.docs : [],
        // docRecords: action.data?.docs !== undefined && action.data?.docs.length ? action.data?.docs[0].documents : [],
        queueCount: action.data?.queueCount ? action.data.queueCount : 0,
        hasNextFolderPage:action.data?.hasNextPage,
        hasPrevFolderPage:action.data?.hasPrevPage

      };
    }
    case "REDIRECT": {
      console.log('case "REDIRECT"', action.data)
      let data = action.data;
      if (!Array.isArray(data)) {
        data = [data]; // Convert single item to array
      }
      console.log('redirect running', data, data[0]?.folder)
      return { ...state, docRecords: data, folder: data[0]?.folder };
    }
    case "INCOME_DOCUMENTS_REDIRECT": {
      console.log('case "REDIRECT_2"', action.data)
      let data = action.data;
      if (!Array.isArray(data)) {
        data = [data]; // Convert single item to array
      }
      console.log('redirect 2 running', data, data[0]?.folder)
      return { ...state, docRecords: data, folder: data[0]?.folder?.id };
    }
    case "LIST_DOCUMENT": {
      return { ...state, docRecords: action.data, totalDocRecords: action.totalDocRecords !== undefined ? action.totalDocRecords : 0, folder: action.folder ? action.folder : state.folder };
    }

    case "LIST_DOCUMENT_SUBADMIN": {
      let documentData = state?.documentData
      let findDoc = action.data.docs.filter(v=> documentData._id === v._id);
      console.log(findDoc.length > 0)
      if(findDoc.length > 0){
        return { ...state, docRecords: action.data.docs, totalDocRecords: action.data.totalDocs !== undefined ? action.data.totalDocs : 0, folder: action.folder ? action.folder : state.folder };
      }else{
        return { ...state, docRecords: [documentData, ...action.data.docs], totalDocRecords: action.data.totalDocs !== undefined ? action.data.totalDocs : 0, folder: action.folder ? action.folder : state.folder };
      }
    }
    
    case "UPDATE_DOCUMENT_LIST": {
      return { ...state, docRecords: action.data }
    }
    case "UPDATE_DOCUMENT_RECORDS": {
      console.log('case "UPDATE_DOCUMENT_RECORDS"', action.data)
      return { ...state, totalDocRecords: action.totalDocRecords !== undefined ? action.totalDocRecords : state.totalDocRecords };
    }
    case "DOCUMENT_DETAILS": {
      console.log('case "DOCUMENT_DETAILS"', action.data)
      return { ...state, details: action.data };
    }

    case "LIST_FILE_MENU": {
      console.log('case "LIST_FILE_MENU"', action.data)
      return { ...state, fileMenu: action.data };
    }

    case "DOCUMENT_DATA": {
      console.log('case "DOCUMENT_DATA"', action.data)
      let docRecords = state?.docRecords.length ? state?.docRecords : action.data;
      if (!Array.isArray(docRecords)) {
        docRecords = [docRecords]; // Convert single item to array
      }
      let docList = docRecords?.map(item => {
        if (item._id === action?.data._id) {
          item = {...item};
          item.is_correct = action?.data?.is_correct;
          item.accepted_itms = action?.data?.accepted_itms;
          item.is_verified = action?.data?.is_verified;

          if (action?.data?.payDate) {
            item.payDate = action?.data?.payDate;
          }
          if (action?.data?.SuitableEmployer) {
            item.SuitableEmployer = action?.data?.SuitableEmployer;
          }

          if (action?.data?.SuitableBorrower) {
            item.SuitableBorrower = action?.data?.SuitableBorrower;
          }
          if (action?.data?.GrossEarningsThroughDate) {
            item.GrossEarningsThroughDate = action?.data?.GrossEarningsThroughDate;
          }

          
        


        }
        delete item.pdf_url_buffer;
        return item;
      });

      console.log('action data document data ->', docList)

      // delete action.data.pdf_url_buffer;

      return { ...state, docRecords: docList, fileData: action.data,selectedFileId: action?.data?._id };
    }
    
    case "SET_SELECTED_FILE": {
      console.log( 'sdasdasda->',action?.selectedFileId )
      return { ...state, selectedFileId: action?.selectedFileId };
    }


    case "DOCUMENT_DETAIL": {
      return { ...state, documentData: action.data };
    }

    case "DOCUMENT_DETAIL_ID": {
      return { ...state, documentDataId: action.data };
    }


    case "DOCUMENT_DATA_LIST": {

      return { ...state, fileData: action.data, docRecords: action.data.docs,totalDocRecords:action.data.totalDocs };
    }
    case "PREV_DOC_RECORD": {

      console.log('case "PREV_DOC_RECORD"', action.data)
      return { ...state, prevFile: action.data }
    }
    case "VALIDATION_JSON": {
      console.log('case "VALIDATION_JSON"', action.data)
      return { ...state, validationJson: action.data };
    }
    case "PAGE": {
      console.log('case "PAGE"', action.data)
      return { ...state, page: action.data };
    }
    case "RIGHT_TAG_CLICKED": {
      return { ...state, isRightClicked: action.data };
    }

    case "RESET_DATA": {

      console.log('fileDatafilea',action.data)
      return { ...state, jsonMeta: {}, xmlMeta: {}, fileData: {} };
    }
    case "JSON_META": {

      return { ...state, jsonMeta: { [action?.page]: action.data } };
    }
    case "JSON_META_PAGE": {
      let jsonMeta = state.jsonMeta;
      jsonMeta = { ...jsonMeta, [action?.page]: action.data };
      return { ...state, jsonMeta: jsonMeta };
    }
    case "XML_META": {
      return { ...state, xmlMeta: { [action?.page]: action.data } };
    }

    case "XML_META_PAGE": {
      let xmlMeta = state.xmlMeta;
      xmlMeta = { ...xmlMeta, [action?.page]: action.data };
      return { ...state, xmlMeta: xmlMeta };
    }
    case "DOCUMENT_URL":
      return { ...state, docUrl: action.data };
    case "FILE_VERSION":
      return { ...state, fileVersions: action.data };
    case "REVISIONS":
      return { ...state, revisions: action.data };
    case "SELECTED_REVISION":
      return { ...state, selectedRevision: action.data };
    case "FILE_LATEST_VERSION":
      return { ...state, latestVersion: action.data };
    case "FILE_LATEST_REVISION":
      return { ...state, latestRevision: action.data };
    case "FILE_SELECTED_VERSION":
      return { ...state, selectedVersion: action.data };
    case "SET_RIGHTSIDEBAR": {
      return { ...state, isOn: action.data }
    }
    case "SET_LEFTSIDEBARCICON": {
      return { ...state, cIcon: action.data }
    }
    case "SET_ACCEPTED": {
      return { ...state, accepted: action.data }
    }
    case "UPDATE_DOCUMENT_FAV_STATUS": {

      let docRecords = state.docRecords;
      let docList = docRecords?.map(item => {
        if (item._id === action.data.id) {
          item.favorite = action.data.favorite;
        }
        return item;
      });
      return { ...state, docRecords: docList };
    }
    case "APPEND_DOCUMENT_LIST": {

      //   let docRecords = action.data;
      let docRecords = state?.docRecords;
      // let docList = docRecords?.length ? [...docRecords, ...action.data] : action.data;
      let docList = docRecords?.length ? [...action.data] : action.data;
      let totalDocRecords = action?.totalDocs ? action?.totalDocs : state?.totalDocRecords
      return { ...state, docRecords: docList,totalDocRecords:totalDocRecords };
    }

    case "APPEND_DOCUMENT_LIST_SUBADMIN": {
      let docRecords = state?.docRecords
      let findDoc = action.data.filter(v=> docRecords[0]._id === v._id);
      if(findDoc.length > 0){
        return { ...state, docRecords: action.data };
      }else{
        return { ...state, docRecords: [...docRecords, ...action.data] };
      }
    }
    
    case "TOTAL_RECORDS": {
      let totalDocRecords = state.totalDocRecords;
      totalDocRecords = state.totalDocRecords + action.data;
      return { ...state, totalDocRecords: totalDocRecords };
      // if(totalDocRecords > 10) {
      //   return { ...state, totalDocRecords: totalDocRecords, hasNextPage:true };
      // }else{
      //   return { ...state, totalDocRecords: totalDocRecords };
      // }
    }

    case "SET_FOLDER_ID": {
      return { ...state, folder: action.data };
    }

    case "APPEND_FOLDER_LIST": {
      let folderRecords = state.folderRecords;
      // let docList = [...folderRecords, ...action.data];
      let docList = [...action.data];
      return { ...state, folderRecords: docList };
    }
    case "UPDATE_QUEUE_COUNT": {
      let queueCount = state.queueCount;
      if (queueCount) {
        queueCount = state.queueCount - 1;
      }
      return { ...state, queueCount: queueCount };
    }
    case "UPDATE_DOCUMENT_FILTER": {

      return { ...state, filter: action.data };
    }
    case "UPDATE_FOLDER_LABEL": {

      return { ...state, folderLabel: action.data };
    }
    case "UPDATE_FOLDER_SORT": {

      return { ...state, folderSort: action.data };
    }
    case "APPEND_TOTAL_RECORDS": {
      let totalDocRecords = state.totalDocRecords;
      totalDocRecords = state.totalDocRecords + action.data;
      return { ...state, totalDocRecords: totalDocRecords, totalFolderRecords: action.foldercount };
    }
    case "UPDATE_SELECTED_FOLDER": {
      let folderRecords = state.folderRecords;
      folderRecords.map((item) => {
        if (item._id == action.data.folder) {
          item.is_correct = action.data.is_correct;
        }
      })
      return { ...state, folderRecords: folderRecords };
    }
    case "UPDATE_FOLDER": {
      let folderRecords = state.folderRecords;
      folderRecords.map((item) => {
        if (item._id == action.data._id) {
          item.is_verified = action.data.is_verified;
        }
      })
      return { ...state, folderRecords: folderRecords };
    }

    case "ENABLE BUTTON": {
      return { ...state, enableButton: action.data };
    }
    case "SET_VIEW_RECORD": {
      return { ...state, view: action.data };
    }
    case "SET_PREV_ACTIVEID": {
      // console.log('action.data ',action.data );
      return { ...state, activeId: action.data };
    }
    case "UPDATE_FOLDER_DATA": {
      let folderRecords = state.folderRecords;
      folderRecords.map((item) => {
        if (item._id == action.data._id) {
          item.is_verified = action.data.is_verified;
          item.is_correct = action.data.is_correct;
        }
      })
      return { ...state, folderRecords: folderRecords };
    }
    case "DOCUMENT_LOGS_LISTING": {
      return { ...state, documentLogs: action.data }

    }
    case "RESET_DOCUMENT_LOGS_LISTING": {
      return { ...state, documentLogs: [] }

    }

    case "MY_ASSIGNED": {
      return {...state, myAssigned: action.data}
    }

    case "OPENED_TAB": {
      return { ...state, openedTab: action.data }
    }


    case "LOGOUT":
      return initialState;
    default:
      return state;

  }
};
